import { institutionTypes } from '../../config/salary-statistics'
import { formatToDKK, getMonthName } from '../../lib/salary-statistics/tools'
import CustomPopover from './popover'
import Graph from './graph'
import { type Salaries, type SelectedInputs } from './salary-statistics'
import { getLastSuccessfulDate } from '../../lib/salary-statistics/session-storage'

function SalaryStatisticsOverview({
  salaries,
  selectedInputs,
}: {
  salaries: Salaries
  selectedInputs: SelectedInputs
}) {
  const month = getLastSuccessfulDate()?.month
  const year = getLastSuccessfulDate()?.year

  const {
    institutionType: institutionTypeValue,
    seniority,
    weeklyHours,
  } = selectedInputs

  const institutionType = institutionTypes.find(
    (type) => type.value === institutionTypeValue,
  )?.overviewLabel

  return (
    <div className="salary-statistics--overview">
      Pædagoger med{' '}
      <strong className="typo__bordeaux-color">{seniority} års</strong>{' '}
      anciennitet, som arbejder{' '}
      <strong className="typo__bordeaux-color">{weeklyHours} timer</strong> om
      ugen på{' '}
      <strong className="typo__bordeaux-color">{institutionType}</strong>,
      tjener typisk{' '}
      <strong className="typo__bordeaux-color">
        {salaries.fr25 && formatToDKK(salaries.fr25)}
        {'-'}
        {salaries.fr75 && formatToDKK(salaries.fr75)}
      </strong>{' '}
      om måneden inkl. pension.
      <span>
        <CustomPopover>
          <p>
            Den angivne løn er inkl. pension, arbejdstidsbestemte ydelser (som
            fx skolepædagogtillæg, aften-/nat-/weekendarbejde), men ekskl.
            særlig feriegodtgørelse og overarbejde. Lønniveauet i statistikken
            inkluderer således også lokale tillæg.
          </p>
          <p>
            Statistikken er landsdækkende. Husk, at løn kan variere afhængig af
            den specifikke stilling, kvalifikationer, lokale aftaler i
            kommunerne, arbejdssted mm.
          </p>
        </CustomPopover>
      </span>
      {salaries && <Graph salaries={salaries} />}
      {month && year && (
        <div>
          <p className="typo__black-color--50 typo__italic">
            Lønniveauet er opgjort {getMonthName(month)} {year} (Kilde: Sirka,
            KRL)
          </p>
        </div>
      )}
    </div>
  )
}

export default SalaryStatisticsOverview
